import React from 'react'
import Card from './Card'

const CardSection = ({data, featuress,customClass}) => {
   
  return (
    <div className={`featured-wrapper ${customClass}`}>
        <div className="featured-main-container">
          <section className="feature-content-section">
            <div className="feature-text-content">
              <h1>{data.heading}</h1>
              <p>{data.paragraph}</p>
              {/* <button className="cta-button">{data.buttonText}</button> */}
            </div>
          </section>
          <Card features={featuress} customClass=''/>
        </div>
    </div>
  )
}

export default CardSection